import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab } from "react-bootstrap";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { DatePicker } from "rsuite";
import {
  createPlayerSubscription,
  getPackageType,
  getPlayerSubscription,
  getPlayerSubscriptionSearch,
} from "../../../services/academicService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDate } from "../../../utils/helperFunction";

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Package", sortingVale: "name" },
  { heading: "Amount", sortingVale: "education" },
  { heading: "Effective Date", sortingVale: "mobile" },
  { heading: "Status", sortingVale: "status" },
  { heading: "Action", sortingVale: "action" },
];

const Packages = () => {
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [subscription, setSubscription] = useState([]);
  const [packageType, setPackageType] = useState([]);
  const [selectedPackageType, setSelectedPackageType] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("ACTIVE");
  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    ammount: "",
    effectiveDate: "",
    status: "ACTIVE",
  });

  const statusOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  function SotingData(name) {
    const sortedPeople = [...subscription];
    switch (name) {
      case "packageType":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.packageType.localeCompare(b.packageType)
            : b.packageType.localeCompare(a.packageType);
        });
        break;
      case "amount":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.amount.localeCompare(b.amount)
            : b.amount.localeCompare(a.amount);
        });
        break;
      case "effectiveDate":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.effectiveDate.localeCompare(b.effectiveDate)
            : b.effectiveDate.localeCompare(a.effectiveDate);
        });
        break;
      default:
        break;
    }
    setSubscription(sortedPeople);
  }

  const handleStatusChange = (selected) => {
    setFormData((prev) => ({
      ...prev,
      status: selected?.value || "",
    }));
  };

  useEffect(() => {
    fetchSubscription();
    fetchPackageType();
  }, []);

  useEffect(() => {
    fetchSubscription();
  }, [status, search]);

  async function fetchSubscription() {
    try {
      const res = await getPlayerSubscriptionSearch(status, search);
      setSubscription(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  async function fetchPackageType() {
    try {
      const res = await getPackageType();
      setPackageType(res);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  function DataSearch(e) {
    const updatesDate = subscription.filter((item) => {
      let selectdata =
        `${item.packageType} ${item.effectiveDate} ${item.amount}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setSubscription([...updatesDate]);
  }

  const validate = () => {
    const newErrors = {};

    if (!formData.ammount) {
      newErrors.ammount = "Amount is required";
    } else if (Number(formData.ammount) <= 0) {
      newErrors.ammount = "Amount must be greater than 0";
    }
    if (!formData.effectiveDate)
      newErrors.effectiveDate = "Effective Date is required";
    if (!selectedPackageType)
      newErrors.packageType = "Package Type is required";
    if (!formData.status) newErrors.status = "Status is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // return true if no errors
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const payload = {
      packageTypeId: selectedPackageType.value,
      ammount: Number(formData.ammount),
      effectiveDate: formData.effectiveDate, // already "YYYY-MM-DD"
      status: formData.status,
    };

    // If editing, include id
    if (editingId) {
      payload.id = editingId;
    }

    try {
      const res = await createPlayerSubscription(payload);
      if (res) {
        toast.success(
          editingId
            ? "Updated Subscription successfully!"
            : "Created Subscription successfully!",
          {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          },
        );
        fetchSubscription();
        handleCancel();
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleCancel = () => {
    setSelectedPackageType(null);
    setFormData({
      ammount: "",
      effectiveDate: "",
      status: "ACTIVE",
    });
    setEditingId(null);
    setErrors({});
  };

  const packageOptions = packageType?.map((type) => ({
    value: type.id,
    label: type.name,
  }));

  return (
    <>
      <PageTitle activeMenu={"All Package"} motherMenu={"Packages"} />
      <div className="row">
        <div className="col-xl-12 col-xxl-12 col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                Package {editingId ? "Updation" : "Creation"}
              </h5>
            </div>

            <div className="card-body">
              <form>
                <div className="row">
                  {/* Name of the Student */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="studentName">
                        Package Type <span className="required">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        value={selectedPackageType}
                        options={packageOptions}
                        onChange={(d) => {
                          setSelectedPackageType(d);
                          setErrors((prev) => ({
                            ...prev,
                            packageType: "",
                          }));
                        }}
                        placeholder="Select Package Type"
                        className="custom-react-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderColor: errors.packageType
                              ? "#FF1616"
                              : base.borderColor,
                            boxShadow: errors.packageType
                              ? "0 0 0 1px #FF1616"
                              : base.boxShadow,
                            "&:hover": {
                              borderColor: errors.packageType
                                ? "#FF1616"
                                : base.borderColor,
                            },
                          }),
                        }}
                      />
                      {errors.packageType && (
                        <small className="text-danger m-lg-2">
                          {errors.packageType}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* Date of Birth */}
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Effective Date <span className="required">*</span>
                      </label>
                      <div className="input-hasicon mb-xl-0 mb-3">
                        <DatePicker
                          placeholder="Select Effective Date"
                          className="picker-suit"
                          value={
                            formData.effectiveDate
                              ? new Date(formData.effectiveDate)
                              : null
                          }
                          onChange={(date) => {
                            setFormData((prev) => ({
                              ...prev,
                              effectiveDate: date ? formatDate(date) : "",
                            }));
                            setErrors((prev) => ({
                              ...prev,
                              effectiveDate: "",
                            }));
                          }}
                          status={errors.effectiveDate ? "error" : ""}
                          shouldDisableDate={(date) => date > new Date()}
                        />

                        <div className="icon">
                          <i className="far fa-calendar" />
                        </div>
                      </div>
                      {errors.effectiveDate && (
                        <small className="text-danger m-lg-2">
                          {errors.effectiveDate}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label" htmlFor="endDate">
                        Amount <span className="required">*</span>
                      </label>
                      <input
                        id="Enter_Amount"
                        name="ammount"
                        placeholder="Enter Amount"
                        type="text"
                        className={`form-control ${
                          errors.ammount ? "is-invalid" : ""
                        }`}
                        value={formData.ammount}
                        onChange={handleChange}
                        required
                      />
                      {errors.ammount && (
                        <small className="text-danger m-lg-2">
                          {errors.ammount}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-label">
                        Status<span className="text-danger">*</span>
                      </label>
                      <Select
                        isSearchable={false}
                        options={statusOptions}
                        placeholder="Select Status"
                        className="custom-react-select"
                        value={statusOptions.find(
                          (option) => option.value === formData.status,
                        )}
                        onChange={(selected) =>
                          setFormData((prev) => ({
                            ...prev,
                            status: selected?.value || "ACTIVE",
                          }))
                        }
                      />
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <button
                      type="submit"
                      className="btn btn-primary me-1"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading
                        ? editingId
                          ? "Updating..."
                          : "Submitting..."
                        : editingId
                          ? "Update"
                          : "Submit"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger light"
                      onClick={handleCancel}
                    >
                      Reset{" "}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            {/* <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav> */}
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Package List </h4>
                    <div className="d-flex align-items-center">
                      <span className="me-3 fw-semibold">Active/Inactive</span>

                      <button
                        type="button"
                        className={`status-switch ${status === "ACTIVE" ? "active" : ""}`}
                        onClick={() =>
                          setStatus(status === "ACTIVE" ? "INACTIVE" : "ACTIVE")
                        }
                      >
                        <span className="switch-text">
                          {status === "ACTIVE" ? "ON" : "OFF"}
                        </span>
                        <span className="switch-circle"></span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length"></div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {subscription?.map((data, ind) => (
                              <tr key={ind}>
                                <td>{ind + 1}</td>
                                <td>{data?.packageType?.name}</td>
                                <td>{data?.ammount}</td>
                                <td>{data?.effectiveDate}</td>
                                <td>{data?.status}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-s sharp btn-primary me-1"
                                    onClick={() => {
                                      setEditingId(data.id); // assuming data.id comes from API
                                      // find the matching option for Select

                                      const selectedType = packageOptions.find(
                                        (opt) =>
                                          opt.value === data?.packageType?.id,
                                      );

                                      setSelectedPackageType(
                                        selectedType || null,
                                      );

                                      setFormData({
                                        ammount: data.ammount || "",
                                        effectiveDate: data.effectiveDate || "", // should already be "YYYY-MM-DD"
                                        status: data.status,
                                      });
                                      setErrors({});
                                    }}
                                  >
                                    <i className="fa fa-pencil" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default Packages;
